<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      role: "role",
    }),
  },
  mounted() {
    if (this.role == "anonymous") {
      this.$router.push({ name: "login" });
    } else if (this.role == "admin") {
      this.$router.push({ name: "admin-home" });
    } else if (this.role == "user") {
      this.$router.push({ name: "candidate-home" });
    } else {
      this.$router.push({ name: "login" });
    }
  },
};
</script>

<style lang="scss" scoped></style>
